import { render, staticRenderFns } from "./CustomerMsg.vue?vue&type=template&id=73e7c09c"
import script from "./CustomerMsg.vue?vue&type=script&lang=js"
export * from "./CustomerMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports